import { router } from '@inertiajs/react'
import { StreamsIndex } from '@/components/streams'
import type { StreamForIndex, PaginationInfo } from '@/types/streams'

interface StreamsIndexPageProps {
  streams: StreamForIndex[]
  filter: string
  pagination: PaginationInfo
}

export default function StreamsIndexPage({ streams, filter, pagination }: StreamsIndexPageProps) {
  const handleEdit = (id: string) => {
    router.visit(`/streams/${id}`)
  }

  const handleDelete = (id: string) => {
    if (confirm('Are you sure you want to delete this stream?')) {
      router.delete(`/streams/${id}`)
    }
  }

  const handleToggleStatus = (id: string) => {
    router.patch(`/streams/${id}/toggle_status`)
  }

  const handleViewReports = (id: string) => {
    router.visit(`/reports?stream_id=${id}`)
  }

  const handleUploadCsv = (id: string) => {
    router.visit(`/items/upload?stream_id=${id}`)
  }

  const handleViewGems = (id: string) => {
    router.visit(`/streams/${id}/gems`)
  }

  const handleCreate = () => {
    router.visit('/streams/new')
  }

  const handleFilterChange = (newFilter: string) => {
    router.visit(`/streams?status=${newFilter}`, { preserveState: true })
  }

  const handlePageChange = (page: number) => {
    router.visit(`/streams?page=${page}`, { preserveState: true })
  }

  return (
    <StreamsIndex
      streams={streams}
      initialFilter={filter}
      pagination={pagination}
      onEdit={handleEdit}
      onDelete={handleDelete}
      onToggleStatus={handleToggleStatus}
      onViewReports={handleViewReports}
      onUploadCsv={handleUploadCsv}
      onViewGems={handleViewGems}
      onCreate={handleCreate}
      onFilterChange={handleFilterChange}
      onPageChange={handlePageChange}
    />
  )
}
